import { AuthorizationProcess, InscriptionCandidate } from '@/Domain/Entities';
import { InscriptionModules, InscriptionStatus, ProcessPhases } from '@/Domain/enum';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MdCheckbox } from '@/Components';

@Component({
    name: 'authorization-section',
    components: { MdCheckbox }
})
export default class AuthorizationSection extends Vue {
    @Prop() readonly isEditMode!: boolean;
    @Prop() readonly isDraftMode!: boolean;
    @Prop() readonly isAdminRole!: boolean;
    @Prop() readonly isAnyModuleEditing!: boolean;
    @Prop() readonly inscription!: InscriptionCandidate;
    @Prop() readonly processPhase!: number;
    @Prop() readonly refuseText!: string;

    InscriptionStatus = InscriptionStatus;
    ProcessPhases = ProcessPhases;

    $refs!: {
        authorizations: HTMLElement;
    };

    setEditMode() {
        this.$emit('setEditMode', InscriptionModules.enum.AUTHORIZATION);
    }

    onSaveEditedAuthorization() {
        this.$emit('edit', InscriptionModules.enum.AUTHORIZATION, this.$refs.authorizations);
    }

    cancelEditMode() {
        this.$emit('cancelEdit', InscriptionModules.enum.AUTHORIZATION);
    }

    onChangeAuthorization(value: any) {
        this.$emit('update:inscription', new InscriptionCandidate(
            {
                ...this.inscription.toServer(),
                authorization: new AuthorizationProcess({
                    ...this.inscription.authorization.toServer(),
                    refuseAuthorization: value
                })
            }));
    }
}
